import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext.jsx';

export default function Nav() {
  const { user, isAdmin, isRep, signOut } = useAuth();

  return (
    <nav className="nav">
      <div className="nav-brand">
        <img src="/logo-192.png" alt="" width="28" height="28" />
        <h1>Pest Plan Manager</h1>
      </div>
      {/* Reps (2026-09-21) get a stripped-down nav -- just enough to sign
          someone up and grab their own QR code. Current Plans and every
          admin screen below call CSR+-gated APIs a rep account would just
          get a 403 from, so there's no point linking to them. */}
      {!isRep && (
        <NavLink to="/" end>
          Current Plans
        </NavLink>
      )}
      <NavLink to="/orders/new">New Sign Up</NavLink>
      {isRep && <NavLink to="/my-qr-code">My QR Code</NavLink>}
      {isAdmin && <NavLink to="/approvals">Approvals</NavLink>}
      {isAdmin && <NavLink to="/admin/products">Product Config</NavLink>}
      {isAdmin && <NavLink to="/admin/sales-credit">Sales Credit</NavLink>}
      {isAdmin && <NavLink to="/admin/reps">Rep QR Codes</NavLink>}
      <div className="user">
        {user?.name} <br />
        <span style={{ textTransform: 'capitalize' }}>{user?.role}</span>
        <div style={{ marginTop: 8 }}>
          <a href="#" onClick={(e) => { e.preventDefault(); signOut(); }}>
            Sign out
          </a>
        </div>
      </div>
    </nav>
  );
}
